import React, { useEffect } from "react";
import { checkStoreStatus } from "../../utils/storeHours";

export default function CheckoutSuccess({
  getUkTime,
  whatsappNumber,
  encryptedOrderId,
  onTrack,
  onBackToMenu,
  forcedOpen = false,
}) {
  const { hour } = getUkTime();
  // Same opening rules as the rest of the site; an admin "force open" overrides the schedule.
  const { isTakeawayOpen } = checkStoreStatus();
  const closedNow = !forcedOpen && !isTakeawayOpen;


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="w-full max-w-xl mx-auto rounded-3xl border border-[#fa9324]/30 bg-white p-8 shadow-lg">
      <div className="space-y-6">

        {/* success tick */}
        <div className="flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#fa9324] text-white text-3xl shadow-md">
            ✓
          </div>
        </div>

        {/* heading */}
        <div className="text-center">
          <h2 className="text-2xl font-bold text-black mb-2">
            Your order has been received
          </h2>
        </div>

        {closedNow && (
          <div className="rounded-2xl border border-red-300 bg-red-50 px-5 py-4 text-center shadow-sm">
            <p className="font-semibold text-red-600">
              {hour < 13
                ? "This order will only be processed when the restaurant opens at 1 PM."
                : "The restaurant is closed for the night. This order will only be processed when we open at 1 PM tomorrow."}
            </p>
          </div>
        )}

        {!closedNow && (
          <p className="text-center text-black/70 font-medium">
            Your order is now being processed.
          </p>
        )}

        <div className="text-center">
          <a
            href={`https://wa.me/${whatsappNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-[15px] font-semibold text-[#fa9324] hover:opacity-80"
          >
            <i className="fab fa-whatsapp text-xl" />
            Chat with us on WhatsApp
          </a>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">

          <button
            className="flex items-center justify-center gap-2 px-6 py-4 rounded-full bg-[#fa9324] text-black font-bold shadow-lg shadow-[#fa9324]/40 hover:opacity-90 transition active:scale-[0.98]"
            onClick={onTrack}
            disabled={!encryptedOrderId}
          >
            <span className="material-icons text-lg">receipt_long</span>
            Track your order
          </button>

          <button
            className="px-6 py-4 rounded-full bg-black/5 text-black/70 font-semibold hover:bg-black hover:text-white transition active:scale-[0.98]"
            onClick={onBackToMenu}
          >
            Back to menu
          </button>

        </div>

      </div>
    </section>
  );
}